<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`试验数据填写【${this.activeInfo.reportCode}】【${this.activeInfo.projectName}】`"
    width="100vw"
    height="100vh"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset()"
  >
    <keep-alive>
      <component v-loading="dataLoading" ref="templateComponent" class="template-common" :is="currentComponent"></component>
    </keep-alive>

    <div slot="footer" class="dialog-footer">
      <div>
        <el-radio-group v-model="dataType" @change="handleDataType">
          <el-radio-button label="tieta">铁塔</el-radio-button>
          <el-radio-button label="jingujian">紧固件</el-radio-button>
          <el-radio-button label="jinju">金具</el-radio-button>
          <el-radio-button label="daoxian">导线</el-radio-button>
        </el-radio-group>
      </div>

      <div>
        <el-button @click="$emit('update:visible', false)">关 闭</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
      </div>
    </div>
  </drag-dialog>
</template>

<script>
import SampleTT from './sampleTemplate/SampleTT';
import SampleJGJ from './sampleTemplate/SampleJGJ';
import SampleJJ from './sampleTemplate/SampleJJ';
import SampleDX from './sampleTemplate/SampleDX';

export default {
  components: {
    SampleTT,
    SampleJGJ,
    SampleJJ,
    SampleDX
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dataLoading: false,
      dataType: 'tieta',
      dataTypeOptions: [
        {
          label: '铁塔',
          value: 'tieta',
          template: 'SampleTT'
        },
        {
          label: '紧固件',
          value: 'jingujian',
          template: 'SampleJGJ'
        },
        {
          label: '金具',
          value: 'jinju',
          template: 'SampleJJ'
        },
        {
          label: '导线',
          value: 'daoxian',
          template: 'SampleDX'
        }
      ],
      currentComponent: 'SampleTT',
      submitLoading: false
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val) {
      }
    }
  },
  methods: {
    // 获取原始数据回显信息
    async getFlowDeliverDetail() {},
    handleDataType() {
      this.currentComponent = this.dataTypeOptions.find(item => item.value === this.dataType).template;
    },
    // 定位到对应样品
    handleLocation() {},
    // 提交录入数据
    async handleSubmit() {
      this.$message.success('提交成功!');
      this.$emit('refresh');
      this.$emit('update:visible', false);
    }
  },
  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.el-button--mini.is-circle {
  padding: 5px;
}

.search-item {
  margin-right: auto;

  .el-select {
    width: 220px;
    margin-right: 14px;
  }
}

.el-input,
.el-select {
  width: 100%;
}
</style>
